import script from "./AttendanceChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./AttendanceChart.vue?vue&type=script&setup=true&lang=ts"

import "./AttendanceChart.vue?vue&type=style&index=0&id=504c2b72&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-504c2b72"]])

export default __exports__